// src/components/SellerLayout.tsx
import React, { useState, useEffect } from 'react';
import { Outlet, useLocation } from "react-router-dom";
import SellerHeader from "./SellerHeader";
import SellerSidebar from "./SellerSidebar";

const SellerLayout: React.FC = () => {
    // Mobile par default false (band), Desktop par true (khula)
    const [isSidebarOpen, setSidebarOpen] = useState(window.innerWidth > 768);
    const location = useLocation();

    // Jab bhi route change ho (mobile user click kare), sidebar band kar do
    useEffect(() => {
        if (window.innerWidth < 768) {
            setSidebarOpen(false);
        }
    }, [location]);

    return (
        <div className="min-h-screen bg-gray-50 flex flex-col font-sans select-none">
            {/* Top Header */}
            <SellerHeader toggleSidebar={() => setSidebarOpen(!isSidebarOpen)} />

            <div className="flex flex-1 pt-[70px] relative">
                
                {/* MOBILE OVERLAY (Backdrop) - Sirf Mobile pe dikhega jab menu khula ho */}
                {isSidebarOpen && (
                    <div 
                        className="fixed inset-0 bg-black/50 z-30 md:hidden backdrop-blur-sm transition-opacity"
                        onClick={() => setSidebarOpen(false)}
                    ></div>
                )}

                {/* Sidebar Component */}
                <SellerSidebar isOpen={isSidebarOpen} closeSidebar={() => setSidebarOpen(false)} />

                {/* Main Content Area */}
                <main 
                    className={`flex-1 p-4 md:p-6 transition-all duration-300 w-full
                        ${isSidebarOpen ? 'md:ml-64' : 'ml-0'} 
                    `}
                >
                    <div className="max-w-7xl mx-auto">
                        <Outlet />
                    </div>
                </main>
            </div>
        </div>
    );
};

export default SellerLayout;